// Service Worker - apenas registro e cache (push removido)
export function register() {
  if (!('serviceWorker' in navigator)) {
    console.log('Service Worker não suportado neste navegador');
    return;
  }

  window.addEventListener('load', async () => {
    const swUrl = `${process.env.PUBLIC_URL || ''}/service-worker.js`;

    try {
      const response = await fetch(swUrl, { method: 'HEAD' });
      const contentType = (response.headers.get('content-type') || '').toLowerCase();
      // Alguns proxies/CDN não enviam Content-Type no HEAD ou usam tipo genérico.
      const mimeOk =
        !contentType ||
        contentType.includes('javascript') ||
        contentType.includes('ecmascript');
      if (!response.ok || !mimeOk) {
        console.warn('Service worker não registrado (arquivo ausente ou MIME inválido).', {
          status: response.status,
          contentType: contentType || '(vazio)'
        });
        return;
      }

      const registration = await navigator.serviceWorker.register(swUrl);
      console.log('Service worker registrado com sucesso!', registration);

      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        if (newWorker) {
          newWorker.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              console.log('Novo service worker instalado e ativo');
            }
          });
        }
      });
    } catch (error) {
      console.error('Erro durante o registro do service worker:', error);
    }
  });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        registration.unregister();
      })
      .catch((error) => {
        console.error('Erro durante o desregistro do service worker:', error);
      });
  }
}
